import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useApiStore from '../apiStore/useApiStore';
import { sentryClient } from './clients/sentryClient';
import { errorReportingStore } from './errorReportingStore';

const useErrorReportingStore = createStore({
  creator: errorReportingStore(sentryClient, {
    useApiStore: lazyDependency(() => useApiStore),
  }),
  id: 'errorReporting',
  ignoreReset: true,
  middlewares: {
    devtools: true,
  },
});

export default useErrorReportingStore;
